import { render, staticRenderFns } from "./PageViewModal.vue?vue&type=template&id=6bcc8314"
import script from "./PageViewModal.vue?vue&type=script&lang=js"
export * from "./PageViewModal.vue?vue&type=script&lang=js"
import style0 from "./PageViewModal.vue?vue&type=style&index=0&id=6bcc8314&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports